<script setup>
const props = defineProps({
  maxAmount: {
    type: Number,
    required: true,
  },
  actualAmount: {
    type: Number,
    required: true,
  },
});

const rolloverPercentage = computed(() => {
  const percentage = ((props.actualAmount / props.maxAmount) * 100).toFixed(2);

  if (percentage > 100) {
    return 100;
  }

  return percentage;
});
</script>

<template>
  <div>
    <div class="flex justify-between text-xs">
      <span class="text-gray-500" v-if="rolloverPercentage < 100"
        >Falta <b>{{ money(maxAmount - actualAmount) }}</b> para completar o rollover</span
      >
      <span class="text-brand-primary" v-else>Rollover completo!</span>
      <span class="font-bold text-brand-primary">{{ rolloverPercentage }}%</span>
    </div>
    <div class="mt-2">
      <div class="h-2 rounded-full bg-gray-600">
        <div
          class="h-full rounded-full bg-brand-primary transition-all duration-300"
          id="progress-bar"
          :style="`width: ${rolloverPercentage}%;`"
        ></div>
      </div>
    </div>
  </div>
</template>
